/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_EyebrowInputs */

const en_endpoint_reference_eyebrow = /** @type {(inputs: Endpoint_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference`)
};

const zh_hans1_endpoint_reference_eyebrow = /** @type {(inputs: Endpoint_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参考`)
};

const pt_br2_endpoint_reference_eyebrow = /** @type {(inputs: Endpoint_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referência`)
};

const es_endpoint_reference_eyebrow = /** @type {(inputs: Endpoint_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referencia`)
};

const fr_endpoint_reference_eyebrow = /** @type {(inputs: Endpoint_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Référence`)
};

const de_endpoint_reference_eyebrow = /** @type {(inputs: Endpoint_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenz`)
};

const ru_endpoint_reference_eyebrow = /** @type {(inputs: Endpoint_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Справочник`)
};

const it_endpoint_reference_eyebrow = /** @type {(inputs: Endpoint_Reference_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riferimento`)
};

/**
* | output |
* | --- |
* | "Reference" |
*
* @param {Endpoint_Reference_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_eyebrow = /** @type {((inputs?: Endpoint_Reference_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_eyebrow(inputs)
	if (locale === "es") return es_endpoint_reference_eyebrow(inputs)
	if (locale === "fr") return fr_endpoint_reference_eyebrow(inputs)
	if (locale === "de") return de_endpoint_reference_eyebrow(inputs)
	if (locale === "ru") return ru_endpoint_reference_eyebrow(inputs)
	if (locale === "it") return it_endpoint_reference_eyebrow(inputs)
	return en_endpoint_reference_eyebrow(inputs)
});